import { FormButton } from "../../../components/_input/_button";
import { InputField } from "../../../components/_input/_input";
import { useEffect, useState, useRef, useMemo } from "react";
import { formValidate } from "../../../utils/validation";
import { toast } from "react-toastify";
import Joi from "joi";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import axios from "axios";
import config from "../../../configuration/config";
function OTPCheck({ mobile, onSucess, setSubFunctionRef, goBack, ResendCode }) {
  const { t: trans } = useTranslation(["new"]);
  const [requestForm, setRequestForm] = useState({ code1: "", code2: "", code3: "", code4: "" });
  const [error, setError] = useState({});
  const [correctValidate, setCorrectValidate] = useState(null);
  const [identityNumber, setIdentityNumber] = useState(null);
  const [timer, setTimer] = useState("00:00:00");
  const inputRefs = useRef([]);
  const Ref = useRef(null);
  const isMountedRef = useRef(true);
  const subFunctionRef = useRef(null);
  const uniqueIdPrefix = useMemo(() => `otp_${Math.random().toString(36).substr(2, 5)}`, []);
  const modalRef = useRef();
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
      if (Ref.current) clearInterval(Ref.current);
    };
  }, []);

  const schema = Joi.object({
    code1: Joi.string().max(1).required(),
    code2: Joi.string().max(1).required(),
    code3: Joi.string().max(1).required(),
    code4: Joi.string().max(1).required(),
  });
  const resetAll = () => {
    if (Ref.current) clearInterval(Ref.current); // إيقاف العداد
    setTimer("00:00:00"); // تصفير العداد
    setRequestForm({ code1: "", code2: "", code3: "", code4: "" }); // تفريغ الحقول
    setError({}); // تصفير الأخطاء
    setCorrectValidate(null);
    setIdentityNumber(null); // إ                        // السماح بإعادة التشغيل
    document.activeElement?.blur(); // ✅ إغلاق الكيبورد إن وُجد

    setTimeout(() => {
      inputRefs.current[0]?.focus(); // إعادة التركيز بعد لحظة (اختياري)
    }, 200); // التركيز على أول حقل
  };

  const subFunction = (validCode, currentIdentityNumber) => {
    // console.log("OTPCheck subFunction .", currentIdentityNumber);
    if (timer === "00:00:00" && isMountedRef.current) {
      clearTimer(getDeadTime());
      onClickReset();
      setCorrectValidate(validCode);
      setIdentityNumber(currentIdentityNumber);
    }
  };

  useEffect(() => {
    if (setSubFunctionRef) setSubFunctionRef(subFunction);

    return () => {
      // إزالة المرجع عند إلغاء تحميل المكون
      if (setSubFunctionRef) setSubFunctionRef(null, null);
    };
  }, [setSubFunctionRef]);

  useEffect(() => {
    const handlePaste = (event) => {
      const paste = (event.clipboardData || window.clipboardData).getData("text");
      try {
        const matched = paste.trim().replaceAll('"', "").match(/\d{4}/);
        if (!matched) return;
        const code = matched[0].split("");
        setRequestForm({ code1: code[0], code2: code[1], code3: code[2], code4: code[3] });
      } catch (e) {
        console.error(e);
      }
    };
    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, []);

  useEffect(() => {
    if ("OTPCredential" in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({ otp: { transport: ["sms"] }, signal: ac.signal })
        .then((otp) => navigator.clipboard.writeText(otp.code))
        .catch(console.warn);
      return () => ac.abort();
    }
  }, []);

  const getTimeRemaining = (endTime) => {
    const total = Date.parse(endTime) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    return { total, hours, minutes, seconds };
  };

  const startTimer = (e) => {
    const { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0 && isMountedRef.current) {
      setTimer(`${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`);
    }
  };

  const clearTimer = (e) => {
    setTimer("00:02:00");
    if (Ref.current) clearInterval(Ref.current);
    Ref.current = setInterval(() => startTimer(e), 1000);
  };

  const getDeadTime = () => {
    const deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + 120);
    return deadline;
  };

  const onClickReset = () => {
    clearTimer(getDeadTime());
  };
  const submitRequest = async () => {
    const otp = requestForm.code1 + requestForm.code2 + requestForm.code3 + requestForm.code4;
    const result = formValidate(schema, requestForm) ?? {};
    setError(result);

    //console.log("submitRequest :", timer);
    //console.log("otp :", otp);
    //console.log("uniqueIdPrefix :", uniqueIdPrefix);
    if (!isMountedRef.current) {
      return;
    }
    if (timer === "00:00:00") {
      toast.error(trans("new:waiting_period_has_expired"));
      return;
    }

    if (correctValidate) {
      if (correctValidate === otp && isMountedRef.current) {
        resetAll();
        onSucess?.({ OTP: otp });
      } else {
        toast.error(trans("new:please_enter_the_correct_code"));
      }
    } else {
      await handleMatchedIdentityNumberWithOTP(otp);
    }
  };
  const handleMatchedIdentityNumberWithOTP = async ( codeOTP ) => {
    try {
      console.log("codeOTP:", codeOTP);
      if (!identityNumber) return;

      const response = await axios.post("https://appw.hassanjameelapp.com/api/Payment/MatchedAbsherOtpByIdentityNumber", {
        identityNumber: identityNumber,
        codeOTP: codeOTP,
      });

      if (response.status === 200) {
        let userResponse = Array.isArray(response?.data) ? response?.data[0] :response?.data;
        if (userResponse.Correct == 1 || userResponse.correct == 1 ) {
          resetAll();
          onSucess?.({ OTP: codeOTP });
        } else {
          toast.error(trans("new:please_enter_the_correct_code"));
        }
      } else {
        toast.error(trans("new:please_enter_the_correct_code"));
      }
    } catch (error) {
      toast.error(trans("error2:validation_error"));
      console.error(error);
    }
  };
  const handelFocusNext = (index) => document.getElementById("code_" + uniqueIdPrefix + "_" + (index + 1))?.focus();
  const handelFocusBack = (index) => document.getElementById("code_" + uniqueIdPrefix + "_" + (index - 1))?.focus();
  useEffect(() => {
    if (!modalRef.current) return;
    const handleEnterKey = (e) => {
      if (e.key === "Enter" && timer != "00:00:00") {
        e.preventDefault();
        //console.log("handleEnterKey:", timer); // يمنع إعادة تحميل الصفحة أو التصرف التلقائي
        submitRequest();
      }
    };
    const current = modalRef.current;
    current.addEventListener("keydown", handleEnterKey);
    return () => current.removeEventListener("keydown", handleEnterKey);
  }, [requestForm, correctValidate, timer]);
  useEffect(() => {
    inputRefs.current[0]?.focus();
    //console.log("inputRefs:", inputRefs.current);
    document.getElementById("code_" + uniqueIdPrefix + "_1")?.focus();
  }, [inputRefs.current]);
  return (
    <div ref={modalRef} className="sms-check-page container mb-32 nice-apply-theme">
      <div className="otp-wrapper">
        <div className="otp-icon" />
        <label className="otp-label">{trans("new:enter_confirmation_code")}</label>
        <div className="Otp-module flex flex-nowrap nice-gap-5rem flex-wrap language-en">
          {Array.from({ length: 4 }).map((_, index) => (
            <div className="grow" key={"codeDiv_" + index + "_" + uniqueIdPrefix}>
              <InputField
                refValue={(el) => (inputRefs.current[index] = el)}
                key={"code_" + index + "_" + uniqueIdPrefix}
                autoComplete="one-time-code"
                placeholder="0"
                id={"code_" + uniqueIdPrefix + "_" + (index + 1)}
                language="language-en"
                value={requestForm["code" + (index + 1)]}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                length={1}
                extraClasses="no-cursor"
                onKeyDown={(e) => {
                  const val = { ...requestForm };
                  if (e.key === "Backspace") {
                    val["code" + (index + 1)] = "";
                    setRequestForm(val);
                    if (!e.target.value) handelFocusBack(index + 1);
                  } else if (/^[0-9]$/.test(e.key)) {
                    val["code" + (index + 1)] = e.key;
                    setRequestForm(val);
                    handelFocusNext(index + 1);
                  }
                }}
                name={"code" + (index + 1)}
              />
            </div>
          ))}
        </div>

        <FormButton
          name={trans("new:confirm_and_continue")}
          classes={`text-40 otp-submitButton ${requestForm.code1 && requestForm.code2 && requestForm.code3 && requestForm.code4 ? "" : "notActive"}`}
          type="button"
          onClick={submitRequest}
        />

        <h3 className="text-40 my-10 otp-timer text-gray text-center">{timer}</h3>

        <div className="sms-check-footer my-10 flex justify-between">
          <Link to="#" className="text-30 otp-notSend text-gray text-center" onClick={(e) => e.preventDefault()}>
            {trans("new:The_code_hasnt_arrived")}
          </Link>
          <Link
            to="#"
            className="text-30 otp-resendButton text-info text-center"
            onClick={(e) => {
              e.preventDefault();
              if (timer === "00:00:00") ResendCode?.();
            }}>
            {trans("new:Resend_Code")}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default OTPCheck;
